<template>
  <div class="alert" :class="theme">
    <grid direction="stack" horizontal="center">
      <grid-item>
        <Icon :type="icon" :size="2" padding=".5em" />
      </grid-item>
      <grid-item>
        <p class="content">
          <slot></slot>
        </p>
      </grid-item>
    </grid>
  </div>
</template>

<script>
export default {
  name: "alert",
  props: {
    icon: {
      type: String,
      default: "info"
    },
    theme: {
      type: String,
      default: "whiteframe shadowframe"
    }
  }
};
</script>

<style lang="scss">
@import "/../../assets/scss/vars";

.alert {
  &.success {
    .icon {
      color: $success;
    }
  }

  &.error {
    .icon {
      color: $error;
    }
  }

  &.warning {
    .icon {
      color: $warning;
    }
  }

  &.info {
    .icon {
      color: $info;
    }
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./../../assets/scss/vars";

.alert {
  padding: 1em 2em 2em;
  color: #000;
  text-align: center;
  background: #fff;
}
</style>
